import { ModalDialog, ModalDialogBody, ModalDialogCloseButton, ModalDialogContent } from '@vp/visage'
import classnames from 'classnames'
import * as React from 'react'
import { AiOutlineExpand } from 'react-icons/ai'
import styleClasses from './btn-full-view.module.scss'

const BtnFullView: React.FC<{ className?: string }> = ({ children, className }) => {

  const [isFullViewMode, setIsFullViewMode] = React.useState(false)

  const handleFullView = (evt?: React.MouseEvent) => {
    evt?.preventDefault()
    evt?.stopPropagation()
    setIsFullViewMode(x => !x)
  }

  return (
    <>
      <button onClick={handleFullView} className={classnames(styleClasses.fullViewBtn, className)} type="button">
        <AiOutlineExpand className={styleClasses.icon} />
      </button>
      <ModalDialog
        takeOver
        isOpen={isFullViewMode}
        onRequestDismiss={() => setIsFullViewMode(false)}
      >
        <ModalDialogContent fullBleed aria-label="full view content">
          <ModalDialogCloseButton />
          <ModalDialogBody>
            <div className={styleClasses.contentContainer}>
              {isFullViewMode && children}
            </div>
          </ModalDialogBody>
        </ModalDialogContent>
      </ModalDialog>
    </>
  )
}

export default BtnFullView 
